import { useState } from 'react'

// redux
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { showAppModal } from '~/redux/actions/app'

import { Menu } from 'antd'
import { SortAscendingOutlined, SortDescendingOutlined } from '@ant-design/icons'

const iconStyle={
  marginRight: '0px'
}

const CommentSortMenu = props => {

  const { sortKey, isDesc} = props

  const handleClick = e => {
    const { key } = e
    const sortFlag = key === 'hot'? true : !isDesc
    props.callback(`${sortFlag ? '-' : ''}${key}`, key, sortFlag)
  };

  const items = [
    {
      label: '按热度',
      key: 'hot'
    },
    {
      label: <>{sortKey === 'published_at' && (isDesc ? <SortAscendingOutlined style={iconStyle} /> : <SortDescendingOutlined style={iconStyle} />)}按时间</>,
      key: 'published_at'
    }
  ]

  return (
      <div className='post-comment-extra'>
        <Menu mode='horizontal' selectedKeys={[sortKey]} onClick={handleClick} items={items} />
      </div>
  )
}

const mapStateToProps = (state) => ({
  token: state.user.token,
})

const mapDispatchToProps = dispatch => bindActionCreators({
  showAppModal,
}, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(CommentSortMenu)